import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBwRejEccJQfUGiU-d53NSuKRj6G73cxvM",
  authDomain: "doctor-world-consultancy.firebaseapp.com",
  projectId: "doctor-world-consultancy",
  storageBucket: "doctor-world-consultancy.firebasestorage.app",
  messagingSenderId: "712555283573",
  appId: "1:712555283573:web:bea49fd765d98519aa643c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services conditionally since measurementId is not provided
let analytics;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.log('Analytics not initialized - no measurementId provided');
}

const storage = getStorage(app);
const auth = getAuth(app);
const db = getFirestore(app);

// Add additional debugging and configuration for auth in subdirectory
if (typeof window !== 'undefined') {
  console.log('Firebase Auth initialized for:', {
    domain: window.location.hostname,
    pathname: window.location.pathname,
    authDomain: firebaseConfig.authDomain
  });
}

export { app, analytics, storage, auth, db };
